const Shield = function (quality) {
  return {
    slot: 'off_hand',
    type: 'shield',
    quality: quality,
    armorClass: Math.round(7 + quality * 65),
  };
};
module.exports = Shield;
